import { Button } from "@mui/material";
import { QueryErrorResetBoundary } from "@tanstack/react-query";
import type React from "react";
import { ErrorBoundary } from "react-error-boundary";

const ResetQueryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<QueryErrorResetBoundary>
			{({ reset }) => (
				<ErrorBoundary
					onReset={reset}
					fallbackRender={({ resetErrorBoundary }) => (
						<div>
							There was an error!
							<Button variant="contained" color="error" onClick={() => resetErrorBoundary()}>
								Try again
							</Button>
						</div>
					)}
				>
					{children}
				</ErrorBoundary>
			)}
		</QueryErrorResetBoundary>
	);
};

export default ResetQueryProvider;
